import { render, staticRenderFns } from "./ClientsSettingsAm.vue?vue&type=template&id=1a267700&"
import script from "./ClientsSettingsAm.vue?vue&type=script&lang=js&"
export * from "./ClientsSettingsAm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports